import { Card, CardComponentVariant } from "@/components/pageCards/card";
import { useTrans } from "@/translations";

import React from "react";

type Props = {
  fillLevel?: string;
};

export const ContainerFillLevel: React.FC<Props> = ({ fillLevel }) => {
  const { t } = useTrans();

  const fillPercentage = fillLevel ? parseInt(fillLevel) : 0;

  return (
    <Card variant={CardComponentVariant.DRAWER} title="drawerLabels:fillLevel">
      <div className="font-dm-sans mb-4 text-sm">
        {t("hints:fillLevelDescription")}
      </div>
      <div className="relative w-full pb-12">
        <div className="bg-grey1 h-9 w-full">
          <div
            className="bg-grey3 absolute flex h-9 items-center"
            style={{ width: `${fillPercentage}%` }}
          >
            {fillPercentage > 0 && (
              <div className="absolute right-2">{fillPercentage}%</div>
            )}
          </div>
        </div>
        <div className="absolute left-0">0%</div>
        <div className="absolute right-0">100%</div>
      </div>
    </Card>
  );
};
